<img 
  [src]="'data:image/jpg;base64, ' + imageBase64" 
  alt="View Image" 
  width="100%"/>